<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">
    RASPORED LJUDI
    <span class="odabraniTjedan">{{ startDayPrikaz }} - {{ endDayPrikaz }}</span>
    <dx-button [disabled]="pravaZaTrenutniPogled != 2"
      class="ml-15"
      icon="pdffile"
      text="Export"
      hint="Export rasporeda ljudi u PDF"
      stylingMode="outlined"
      type="danger"
      (click)="exportPdf()">
    </dx-button>
    <dx-button [disabled]="pravaZaTrenutniPogled != 2"
      *ngIf="!djelatnici?.length"
      class="ml-15"
      icon=""
      text="Rotiraj smjene"
      hint="Rotiraj smjenu u odnosu na prošli tjedan"
      stylingMode="outlined"
      type="danger"
      (click)="kreirajRaspored()">
    </dx-button>
  </h2>

  <div class="customTable m-40">
    <dx-data-grid
      id="rasporedLjudi"
      [showColumnLines]="true"
      [dataSource]="djelatnici"
      [wordWrapEnabled]="true"
      noDataText="{{ poruka }}"
      keyExpr="idDjelatnik"
      [showColumnLines]="true"
      [showBorders]="false"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onCellPrepared)="onCellPrepared($event)">
      <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
        <div class="naslov">
          <h2 class="mb-0">Raspored ljudi</h2>
          <p class="mt-0">Praćenje ljudi po tjednu, liniji i smjeni</p>
        </div>
        <div class="d-inline ml-15">
          <dx-button
            [disabled]="pravaZaTrenutniPogled != 2"
            icon="plus"
            hint="Dodavanje djelatnika"
            stylingMode="outlined"
            type="success"
            (click)="dodajDjelatnikaPopup()">
          </dx-button>
        </div>
      </div>

      <div *dxTemplate="let data of 'odabirDatuma'">
        <div class="nadzornaDatum">
          <span>Datum</span>
          <dx-date-box
            pickerType="calendar"
            displayFormat='dd.MM.yyyy.'
            placeholder="Odaberite tjedan"
            [value]="dateBoxNedjelja"
            [calendarOptions]="{ firstDayOfWeek: 1 }"
            [disabledDates]="disableDates"
            (onValueChanged)="promjenaDatuma($event)">
            <!-- applyValueMode="useButtons" -->
          </dx-date-box>
        </div>
      </div>

      <div *dxTemplate="let data of 'odabirSmjene'">
        <div class="selectDropdown">
          <span>Smjena</span>
          <dx-select-box
            [disabled]="false"
            [items]="smjene"
            [value]="smjene[0].id"
            valueExpr="id"
            displayExpr="naziv"
            [width]="100"
            (onValueChanged)="promjenaSmjeneFilter($event)"
            (onOpened)="disableItem($event)">
          </dx-select-box>
        </div>
      </div>

      <div *dxTemplate="let data of 'odabirLinije'">
        <div class="selectDropdown">
          <span>Linija</span>
          <dx-select-box
            [disabled]="false"
            [items]="linije"
            [value]="linije[0].id"
            valueExpr="id"
            displayExpr="naziv"
            [width]="250"
            (onValueChanged)="promjenaLinijeFilter($event)"
            (onOpened)="disableItem($event)">
          </dx-select-box>
        </div>
      </div>

      <dxo-search-panel
        [visible]="true"
        [width]="180"
        placeholder="Pretraži...">
      </dxo-search-panel>

      <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 30]"
        [showInfo]="true">
      </dxo-pager>

      <dxi-column
        dataField="djelatnik"
        caption="Ime i prezime"
        [width]="300">
      </dxi-column>
      <dxi-column
        dataField="datumod"
        dataType="date"
        caption="Datum od"
        [width]="120"
        alignment="center"
      ></dxi-column>
      <dxi-column
        dataField="datumdo"
        dataType="date"
        caption="Datum do"
        [width]="120"
        alignment="center"
      ></dxi-column>
      <dxi-column
        dataField="smjena"
        caption="Smjena"
        [width]="100"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="radnoVrijeme"
        caption="Radno vrijeme"
        [width]="150"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="linija"
        caption="Linija"
        alignment="left"
        [width]="250">
      </dxi-column>
      <dxi-column
        dataField="napomena"
        caption="Napomena"
        alignment="left">
      </dxi-column>
      <dxi-column cellTemplate="uredjivanje" [width]="105" alignment="left">
        <div *dxTemplate="let data of 'uredjivanje'">
          <dx-button [disabled]="pravaZaTrenutniPogled != 2" icon="edit" hint="Uredi" (onClick)="urediDjelatnikaPopup(data)"></dx-button>
          <dx-button [disabled]="pravaZaTrenutniPogled != 2" icon="trash" hint="Brisanje djelatnika" (onClick)="obrisiDjelatnikaPopup(data)"></dx-button>
        </div>
      </dxi-column>

      <dxo-summary>
        <dxi-total-item column="djelatnik" summaryType="count"></dxi-total-item>
      </dxo-summary>
    </dx-data-grid>
  </div>

  <!-- POPUPS -->
  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="{{ djelatnikFormaPoruka }}"
    [dragEnabled]="true"
    [closeOnOutsideClick]="true"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
    [(visible)]="ubaciDjelatnikaPopupVisible"
    (onHiding)="onPopupClosed()">

    <div class="mb-15" style="font-size: 18px">
      <strong>{{ startDayPrikaz }} - {{ endDayPrikaz }}</strong>
    </div>
    <div *ngIf="!idDjelatnik && radnici.length" class="odabrani-radnici">
      <strong>Odabrani radnici:</strong>
      <ul>
        <li *ngFor="let radnik of radnici; index as i">
          {{ radnik.djelatnik }}
          <span class="ukloni" (click)="ukloniRadnika(i)">x</span>
        </li>
      </ul>
    </div>
    <dx-text-box *ngIf="idDjelatnik"
      class="mb-15"
      value="{{ odabraniDjelatnik }}"
      [readOnly]="true">
    </dx-text-box>
    <dx-select-box
      *ngIf="!idDjelatnik"
      class="mb-15"
      [dataSource]="sviDjelatnici"
      [(value)]="odabraniDjelatnik"
      displayExpr="ime"
      placeholder="Odaberi djelatnika"
      [searchEnabled]="true"
      [searchExpr]="['ime']"
      (onValueChanged)="odaberiDjelatnika($event)"
      (onClosed)="promjenaDjelatnika()">
    </dx-select-box>
    <dx-select-box
      class="mb-15"
      [items]="smjene"
      [value]="odabranaSmjena"
      valueExpr="id"
      displayExpr="naziv"
      placeholder="Odaberi smjenu"
      (onValueChanged)="promjenaSmjene($event)"
      (onOpened)="disableItem($event)">
    </dx-select-box>
    <div class="dx-field two-columns mb-15">
      <div class="dx-field-value w-50">
        <dx-date-box
          type="time"
          [value]="pocetakSmjene"
          placeholder="Početak smjene"
          interval="60"
          [useMaskBehavior]="true"
          displayFormat="HH:mm"
          [readOnly]="!odabranaSmjena"
          (onValueChanged)="promjenaPocetkaSmjene($event)">
        </dx-date-box>
      </div>
      <div class="dx-field-value w-50">
        <dx-date-box
          type="time"
          [value]="krajSmjene"
          placeholder="Kraj smjene"
          interval="60"
          [useMaskBehavior]="true"
          displayFormat="HH:mm"
          [readOnly]="!odabranaSmjena"
          (onValueChanged)="promjenaKrajaSmjene($event)">
        </dx-date-box>
      </div>
    </div>
    <dx-select-box
      class="mb-15"
      [items]="linije"
      [value]="odabranaLinijaId"
      valueExpr="id"
      displayExpr="naziv"
      placeholder="Odaberi liniju"
      (onValueChanged)="promjenaLinije($event)"
      (onOpened)="disableItem($event)">
    </dx-select-box>
    <div class="mb-15">
      <dx-text-area
        placeholder="Napomena"
        [value]="napomena"
        [height]="100"
        (onValueChanged)="promjenaNapomene($event)">
      </dx-text-area>
    </div>

    <dx-button
      *ngIf="!idDjelatnik"
      [disabled]="
        !odabranaLinijaId ||
        !odabranaSmjena ||
        !radnici.length ||
        !pocetakSmjeneSlanje ||
        !krajSmjeneSlanje || disableGumb"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="Dodaj"
      (onClick)="dodajDjelatnika()">
    </dx-button>
    <dx-button
      *ngIf="idDjelatnik"
      [disabled]="
        !odabranaLinijaId ||
        !odabranaSmjena ||
        !pocetakSmjeneSlanje ||
        !krajSmjeneSlanje"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="Uredi"
      (onClick)="urediDjelatnika()">
    </dx-button>
  </dx-popup>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Obriši djelatnika!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
    [(visible)]="obrisiDjelatnikaPopupVisible">
    <p>Jeste li sigurni da želite obrisati djelatnika sa popisa?</p>
    <dx-button class="dodajButton" stylingMode="outlined" type="success" text="DA" (onClick)="obrisiDjelatnika()"></dx-button>
    <dx-button class="dodajButton" stylingMode="outlined" type="danger" text="NE" (onClick)="obrisiDjelatnikaPopupVisible = false"></dx-button>
  </dx-popup>
</div>
